import { render, staticRenderFns } from "./ProrateAllowanceReport.vue?vue&type=template&id=7cb92e85"
import script from "./ProrateAllowanceReport.vue?vue&type=script&lang=js"
export * from "./ProrateAllowanceReport.vue?vue&type=script&lang=js"
import style0 from "./ProrateAllowanceReport.vue?vue&type=style&index=0&id=7cb92e85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports